import React from "react"
import { ResponsiveGatsbyImage } from "./ResponsiveGatsbyImage"

const ImageOrVideo = ({
  img,
  setRef,
  color,
  rgb,
  fill,
  priority = "video",
  //
  avVideoTeaser,
  sizes,
  style,
  className,
  ...rest
}) => {
  if (!avVideoTeaser?.avVideoTeaser?.mediaItemUrl && !img?.sourceUrl)
    return null

  const imageComponent = img && (
    <ResponsiveGatsbyImage
      style={{ backgroundColor: color && rgb ? `rgb(${rgb})` : null }}
      setRef={setRef}
      className={className}
      src={img.sourceUrl}
      srcSet={img.srcSet}
      sizes={sizes}
      height={img.mediaDetails ? img.mediaDetails.height : "988"}
      width={img.mediaDetails ? img.mediaDetails.width : "1400"}
      {...rest}
    />
  )

  const videoComponent = (
    <video
      // className={className}
      //   className={cn(className, "rounded-inherit object-cover")}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      style={
        fill
          ? {
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "0px",
              left: "0px",
              objectFit: "cover",
            }
          : style
      }
    >
      <source
        src={avVideoTeaser?.avVideoTeaser?.mediaItemUrl}
        // src="https://inspgr.id/app/uploads/2025/05/design-solstice-2-teaser.mp4"
        type="video/mp4"
      />
    </video>
  )

  if (priority === "image") {
    if (img?.sourceUrl) {
      return imageComponent
    }
    return videoComponent
  }

  if (priority === "video") {
    if (avVideoTeaser?.avVideoTeaser?.mediaItemUrl) {
      return videoComponent
    }
    return imageComponent
  }

  return (
    <img
      className={className}
      src="/roundup-tile-feb-19-unicorn_ysma0h.jpg"
      alt=""
    />
  )
}

export default ImageOrVideo
